function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultCfg = {
  childList: true,
  subtree: true,
  attributes: true,
  characterData: true,
  attributeOldValue: true,
  characterDataOldValue: true
};

function _update(el, ctx, value) {
  ctx.handler = value;
  ctx.observer !== void 0 && ctx.observer.disconnect();
  ctx.observer = new MutationObserver(function (list) {
    if (typeof ctx.handler === 'function') {
      var res = ctx.handler(list);

      if (res === false || ctx.once === true) {
        destroy(el);
      }
    }
  });
  ctx.observer.observe(el, ctx.opts);
}

function destroy(el) {
  var ctx = el.__qmutation;

  if (ctx !== void 0) {
    ctx.observer !== void 0 && ctx.observer.disconnect();
    delete el.__qmutation;
  }
}

export default {
  name: 'mutation',
  inserted: function inserted(el, _ref) {
    var _ref$modifiers = _ref.modifiers,
        once = _ref$modifiers.once,
        mod = _objectWithoutProperties(_ref$modifiers, ["once"]),
        value = _ref.value;

    if (el.__qmutation !== void 0) {
      destroy(el);
      el.__qmutation_destroyed = true;
    }

    var ctx = {
      once: once,
      opts: Object.keys(mod).length === 0 ? defaultCfg : mod
    };

    _update(el, ctx, value);

    el.__qmutation = ctx;
  },
  update: function update(el, _ref2) {
    var oldValue = _ref2.oldValue,
        value = _ref2.value;
    var ctx = el.__qmutation;

    if (ctx !== void 0 && oldValue !== value) {
      _update(el, ctx, value);
    }
  },
  unbind: function unbind(el) {
    if (el.__qmutation_destroyed === void 0) {
      destroy(el);
    } else {
      delete el.__qmutation_destroyed;
    }
  }
};